module.exports = __webpack_public_path__ + "media/images/cbma-1f10b8b4d67f14e76b5b484fb7f40216b38971d804fd56d8582e233c127dac27.jpg";